import React, { useState } from "react"
import { useSelector, useDispatch } from "react-redux"

import { IDLE, PENDING } from "const"
import { StateType } from "client/utils"
import {
    StoreType,
    ClearParentsOkrSession,
    DeleteOkrSession,
    setOkrSessionShowConfirmDelete,
    setOkrSessionReloadList,
} from "client/store"
import {
    ConfirmWrapper,
    Confirm,
    ConfirmTitle,
    ConfirmDescription,
    ConfirmBottom,
    Button,
    SpinnerIcon,
} from "client/components"

const ConfirmDelete = () => {
    const activeSession = useSelector((state: StoreType) => state.okrSession.active)
    const showConfirm = useSelector((state: StoreType) => state.okrSession.showConfirmDelete)
    const userData = useSelector((state: StoreType) => state.system.userData)
    const lang = useSelector((state: StoreType) => state.system.lang)
    const dispatch = useDispatch()

    const [deleteState, setDeleteState] = useState<StateType>(IDLE)

    const onCancel = () => {
        dispatch(setOkrSessionShowConfirmDelete(false))
    }

    const onConfirm = () => {
        setDeleteState(PENDING)
        // clear parents
        ClearParentsOkrSession(activeSession.id, userData.accountId).then(() => {
            DeleteOkrSession(activeSession.id, userData.accountId).then(() => {
                setDeleteState(IDLE)
                dispatch(setOkrSessionShowConfirmDelete(false))

                dispatch(setOkrSessionReloadList(false))
                setTimeout(() => {
                    dispatch(setOkrSessionReloadList(true))
                }, 0)
            })
        })
    }

    return (
        <ConfirmWrapper show={showConfirm} onClose={onCancel}>
            <Confirm>
                <ConfirmTitle>{activeSession && activeSession.name}</ConfirmTitle>
                <ConfirmDescription>{lang.deleteSessionConfirm}</ConfirmDescription>

                <ConfirmBottom>
                    <Button row onClick={onCancel}>{lang.cancel}</Button>
                    <Button variant="success" row onClick={onConfirm}>
                        {deleteState === PENDING ? <SpinnerIcon /> : lang.confirm}
                    </Button>
                </ConfirmBottom>
            </Confirm>
        </ConfirmWrapper>
    )
}
export default ConfirmDelete
